import { getLocalStorage } from '../utils'

export async function getPlayers(divisionId, userId) {
    const team = JSON.parse(getLocalStorage("team", "{}"));
    const response = await fetch('api/game/players/' + divisionId + '/' + userId, { headers: { "teamName": team.team } });
    const data = await response.json();
    return data;
}

export async function getRanking(divisionId) {
    const team = JSON.parse(getLocalStorage("team", "{}"));
    const response = await fetch('api/game/ranking/' + divisionId, { headers: { "teamName": team.team } });
    const data = await response.json();
    return data;
}

export async function getPlaces() {
    const team = JSON.parse(getLocalStorage("team", "{}"));
    const response = await fetch('api/places', { headers: { "teamName": team.team } });
    const data = await response.json();
    return data;
}

export async function getCustomGames() {
    const team = JSON.parse(getLocalStorage("team", "{}"));
    const response = await fetch('api/customgame', { headers: { "teamName": team.team } });
    const data = await response.json();
    return data;
}

export async function postAddCustomGame(game) {
    const team = JSON.parse(getLocalStorage("team", "{}"));
    const response = await fetch('api/customgame/Add',
        {
            method: "POST",
            headers: { "teamName": team.team, 'Content-Type': 'application/json;' },
            body: JSON.stringify(game)
        });
    const data = await response.json();
    return data;
}

export async function putModifyCustomGame(game) {
    const team = JSON.parse(getLocalStorage("team", "{}"));
    const response = await fetch('api/customgame/Modify',
        {
            method: "PUT",
            headers: { "teamName": team.team, 'Content-Type': 'application/json;' },
            body: JSON.stringify(game)
        });
    const data = await response.json();
    return data;
}

export async function deleteCustomGame(id) {
    const team = JSON.parse(getLocalStorage("team", "{}"));
    const response = await fetch(`api/customgame/Delete/${id}`,
        {
            method: "DELETE",
            headers: { "teamName": team.team }
        });
    const data = await response.json();
    return data;
}

export async function getTactics(userId) {
    const team = JSON.parse(getLocalStorage("team", "{}"));
    const response = await fetch(`api/tactic/${userId}`, {
        headers: { "teamName": team.team, 'Accept': 'application/json' }
    });
    if (!response.ok) throw new Error(`HTTP ${response.status}`);
    return response.json();
}

export async function postCreateTactic(tactic) {
    const team = JSON.parse(getLocalStorage("team", "{}"));
    const response = await fetch('api/tactic', {
        method: "POST",
        headers: {
            "teamName": team.team,
            'Content-Type': 'application/json',
            'Accept': 'application/json',
        },
        body: JSON.stringify(tactic)
    });
    if (!response.ok) throw new Error(`HTTP ${response.status}`);
    return response.json();
}

export async function putUpdateTactic(tactic) {
    const team = JSON.parse(getLocalStorage("team", "{}"));
    const response = await fetch('api/tactic', {
        method: "PUT",
        headers: {
            "teamName": team.team,
            'Content-Type': 'application/json',
            'Accept': 'application/json',
        },
        body: JSON.stringify(tactic)
    });
    if (!response.ok) throw new Error(`HTTP ${response.status}`);
    return response.json();
}

export async function getTactic(userId, tacticId) {
    const team = JSON.parse(getLocalStorage("team", "{}"));
    const response = await fetch(`api/tactic/${userId}/${tacticId}`, {
        headers: { "teamName": team.team, 'Accept': 'application/json' }
    });
    if (!response.ok) return null;
    return response.json();
}

export async function deleteTactic(userId, tacticId) {
    const team = JSON.parse(getLocalStorage("team", "{}"));
    const response = await fetch(`api/tactic/${userId}/${tacticId}`, {
        method: "DELETE",
        headers: { "teamName": team.team, 'Accept': 'application/json' }
    });
    if (!response.ok) throw new Error(`HTTP ${response.status}`);
    return response.json();
}

export async function postAddPlayers(players) {
    const team = JSON.parse(getLocalStorage("team", "{}"));
    const response = await fetch('api/game/adduserplayers',
        {
            method: "POST",
            headers: { "teamName": team.team, 'Content-Type': 'application/json;' },
            body: JSON.stringify(players)
        });
    const data = await response.json();
    return data ;
}